import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SubSink } from 'subsink';
import { ColDef } from 'ag-grid-community';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { AppConstants, ObservationEvents} from 'src/app/utilities/constant';
import { EventProvider } from 'src/app/services/event';
import { FileUploadComponent } from 'src/app/components/file-upload/file-upload.component';
import { GridConfig } from 'src/app/shared/grid-config';
import { AppGridComponent } from 'src/app/shared/grid/grid-component/grid-component';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';

@Component({
  selector: 'app-sistema',
  templateUrl: './sistema.component.html',
  styleUrls: ['./sistema.component.scss'],
})
export class SistemaComponent implements OnInit {

  @Input() serviceMachineId: any;
  @Input() projectId: any;
  @Input() serviceId: any;
  @Input() isCloneMode = false;
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  public sistemaImagesList: any = [];
  public sistemaGridColumnDefs: ColDef[];
  public sistemaGridConfigItems: GridConfig;
  public isSistemaGridDisplayed = true;
  public subs = new SubSink();
  constructor(
    private backendService: BackendCallService,
    private eventProvider: EventProvider,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private toastService: ToastService,
    private userAuthService: UserAuthService,
    private modalService: ModalService,
    public sharedValue: ShareValuesService
  ) {}

  ngOnInit() {
    this.fnInitialiseSistemaGrid();
    if (this.isCloneMode) {
      this.sistemaImagesList = [];
      this.sharedValue.isGridDataLoading = false;
      setTimeout(() => {
        this.gridComponent?.fnAppendAllDataInGrid(this.sistemaImagesList);
      }, 150);
    } else {
      this.getSistemafileData();
    }
    this.subs.sink = this.eventProvider.event(ObservationEvents.FILE_UPLOAD).subscribe((res) => {
      this.uploadSistema(res)
    })  
  }

  /**
   * upload Sistema
   * @param event 
   * @returns 
   */
  async uploadSistema(event: any) {
    if (this.isCloneMode) {
      return;
    }
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file.name;
      const fileType = file.type;
        const allowedFileTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];
      if (!allowedFileTypes.includes(fileType)) {
        console.error('Unsupported file type!');
        return;
      }
      const file_path = `${this.projectId}/${this.serviceId}/${this.serviceMachineId}/Sistema/`;
      const formData = new FormData();
      formData.append('file', file, fileName);
      const imageFormData = this.sharedValue.prepareImageFormData(formData, [file], file_path);  
      try {
        const response = await this.backendService.uploadImages(imageFormData).toPromise();
        console.log('Upload successful', response);
        await this.updateSistema(response[0]);
      } catch (err) {
        console.error('Error uploading file', err);
      }
    } else {
      console.warn('No file selected for upload');
    }
  }

  /**
   * update Sistema
   * @param data 
   */
  async updateSistema(data){
    const sistemaFilesData ={
      id: '', 
      name: data.file_name,
      type: data.content_type,
      url: data.url,
      driveId: '',
      itemId: '',
      image_Size: data.file_size
    }
    const payload = {
      service_Machine_Id: this.serviceMachineId,
      sistemaFiles: [
        sistemaFilesData
      ]
    };
    const response: any = await this.backendService.isUploadSystemaReport(payload).toPromise();
    if (response == 'Sistema Files Added') {
      this.toastService.presentToast(this.translate.instant('sistema_file_added_succesfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
      await this.getSistemafileData();
    }
    else {
      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');                
    }
  }

  /**
   * getSistemafileData
   */
  async getSistemafileData() {
    this.sistemaImagesList = [];
    await this.backendService.getSystemaFileInfo(this.serviceMachineId).subscribe(res => {
      this.sistemaImagesList = res;
      this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
      setTimeout(() => {
        this.gridComponent?.refreshGridData();
      }, 1000);
    });
  }

  /**
   * Initialise Sistema Grid
   */
  private fnInitialiseSistemaGrid() {
    this.fnCreateSistemaColumnDefs();
    this.fnGetSistemaGridConfigItems();
    setTimeout(() => {
      this.gridComponent?.initializeGrid(false);
    }, 100);
  }

  /**
   * Create SistemaColumnDefs
   */
  private fnCreateSistemaColumnDefs() {
    this.sistemaGridColumnDefs = [
      {
        headerName: this.translate.instant('File_Name'),
        field: 'name',
        minWidth: 150,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value grid-text-color'
      },
      {
        headerName : this.translate.instant('Uploaded_By'),
        field: 'uploadedBy',
        minWidth: 250,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value'
      },
      {
        headerName : this.translate.instant('Uploaded_Date'),
        field: 'uploadedAt',
        minWidth: 150,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value',
        cellRenderer:'dateRenderer'
      },
      {
        headerName: this.translate.instant('Actions'),
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        minWidth: 120,
        maxWidth: 250,
        cellClass: 'float-right',
        headerComponentParams:
          [
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Delete'),
              userAction: this.translate.instant('Delete'),
              url: 'assets/images/Delete.svg'
            }
          ]
      }
    ];
  }

  /**
   * Get SistemaGridConfigItems
   */
  private fnGetSistemaGridConfigItems() {
    this.sistemaGridConfigItems = new GridConfig(
      'id',
      'id',
      false,
      true,
      true,
      false,
      'desc',
      40,
      'no_data_available',
      this.translate.instant('Sistema_Files'),
      '',
      '',
      false,
      1,
      'grid-wrapper-height-40',
      '',
      '',
      '',
      ''
    );
  }
  
  /**
   * on sistema grid cell click
   * 
   * @param params 
   */
  public async fnOnSistemaGridCellClick(params) {
    if (params.data.userAction == this.translate.instant('Delete')) {
      const item = this.translate.instant('sistema_file');
      const itemName = params?.data?.name;
      const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + item + '?';
      const subtitle = `'${itemName}'`;
      const actionText = this.translate.instant('Delete');
      const isActionConfirmed = await this.confirmationService.presentConfirmationModal(
        title,
        actionText,
        true,
        this.translate.instant('Cancel'),
        subtitle
      );
      if (isActionConfirmed) {
        this.deleteSistema(params.data);
      }
    }
  }

  /**
   * deleteSistema
   * @param params 
   */
  public deleteSistema(params) {
  const  payload =  {
      resourceType: 3,
      id: params.id,
      fileName: params.name,
      filePath: params.url,
      modifiedBy: this.userAuthService.getUserList().userId
    }
    this.backendService.deleteResource(payload).subscribe((res: any) => {
        this.getSistemafileData();        
        this.toastService.presentToast(this.translate.instant('file_deleted_succesfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
      }, err => {        
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });       
  }

  /**
   * openModal for uploading sistema
   */
  public async openModal() {
    if (this.isCloneMode) {
      return;
    }
    const modalProps = {
      showDownloadLink: false,
      showSubHeader: false,
      sampleDownload: false,
      acceptTypes: '.pdf, .docx'
    };
    const modalData = await this.modalService.presentModal(FileUploadComponent, modalProps, 'medium-popup-alert-modal');

    let modalResult = '';
    if (modalData && modalData.isActionConfirmed) {
      modalResult = 'Action confirmed in the modal!';
    } else {
      modalResult = 'Action was not confirmed.';
    }
    console.log(modalResult);
  }

}